<template>
  <div class="event" style="margin-right: 10px;">
    <div class="sub-event" :class="{ 'sup-event': i > 0, f: f && i == 0, l: l && i == event.periods.length - 1 }" v-for="(se, i) in event.periods" :key="i">
      <div class="event-cell" v-if="i == 0">
        <div class="event-info">
          <table style="border: none; width: 100%; border-spacing: unset;">
            <tr>
              <td rowspan="2" style="width: 25px;"><favorite-toggler style="height: 18px; width: 18px; color: gray; font-size: 15px; margin-top: 5px;" :active="favorite" type="event" :target="event.id" /></td>
              <td class="time" style="width: 15%;" @click="followEvent">{{ event.time | moment('add', '-3 hours') | moment('DD/MM') }}</td>
              <td @click="followEvent">
                <div class="team">{{ event.home }}</div>
              </td>
              <td rowspan="2" @click="openStatistics">
                <statistic-icon style="float: right; width: 15px; margin-right: 7px;" method="statistic" :pixel-size="15" />
              </td>
            </tr>
            <tr>
              <td class="time" style="width: 15%;" @click="followEvent">{{ event.time | moment('add', '-3 hours') | moment('HH:mm') }}</td>
              <td @click="followEvent">
                <div class="team" v-if="event.away">{{ event.away }}</div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="event-cell" v-else @click="$router.push(`/prematch/sport/${sport.id}/event/${event.id}/period/${se.number}`)">{{ se.name }}</div>
      <div class="factors-1 factors" style="margin-right: 10px;">
        <factor-cell
          class="factor-cell"
          :class="{ f: f && j === se.factors[0].length - 1 && i == 0, l: l && j === se.factors[0].length - 1 && i == event.periods.length - 1 }"
          style="height: 27px; margin-top: 11px;"
          v-for="(factor, j) in se.factors[0]"
          :key="j"
          :event="event.id"
          :factor="factor" />
      </div>
      <div class="factors-2 factors" style="margin-right: 10px;">
        <factor-cell
          class="factor-cell"
          :class="{ f: f && j === se.factors[1].length - 1 && i == 0, l: l && j === se.factors[1].length - 1 && i == event.periods.length - 1 }"
          style="height: 27px; margin-top: 11px;"
          v-for="(factor, j) in se.factors[1]"
          :key="j"
          :event="event.id"
          :factor="factor" />
      </div>
    </div>
  </div>
</template>

<script>
import FavoriteToggler from '@/components/buttons/FavoriteToggler'
import FactorCell from '@/components/sports/matches/FactorCell'
import StatisticIcon from '@/components/icons/StatisticIconGray'

export default {
  components: { FavoriteToggler, FactorCell, StatisticIcon },
  props: {
    favorite: Boolean,
    event: Object,
    sport: Object,
    f: Boolean,
    l: Boolean
  },
  methods: {
    followEvent (event) {
      if (event.target.classList.value === 'statistic-icon') this.openStatistics()
      if (event.target.classList.contains('favorite-toggler')) return
      this.$router.push(`/prematch/sport/${this.sport.id}/event/${this.event.id}`)
    },
    openStatistics () {
      // window.open('https://statistic.sportdemo.ru/betspectrumStatistics?id=' + this.event.id + '&lang=' + this.$i18n.locale, 'statistics', 'width=1000,height=700,menubar=no,toolbar=no,location=no')
      window.open('https://statistic.sportdemo.ru/statistics?lang=' + this.$i18n.locale, 'statistics', 'width=1000,height=700,menubar=no,toolbar=no,location=no')
    }
  }
}
</script>

<style scoped>
.sub-event { display: flex; }
.event-cell { align-items: center; background: rgba(255, 255, 255, .1); cursor: pointer; display: flex; flex: 0 0 32%; max-width: 32%; -webkit-transition: background .3s; -moz-transition: background .3s; -o-transition: background .3s; transition: background .3s; }
.event-cell:hover { background: rgba(255, 255, 255, .15); }
.f .event-cell { border-top-left-radius: 5px; }
.l .event-cell { border-bottom-left-radius: 5px; }
.favorite-toggler { flex-shrink: 0; /* margin: 0 5px; */ z-index: 1; }
.event-info { flex: 1 1; min-width: 0; /* padding: 5px 8px 5px 0; */ }
.team { /* height: 17px; */ overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 155px; }
.comment { display: flex; height: 17px; width: 100%; }
.number { margin-right: 8px; }
.time { color: #713592; }
.sub-event { margin-top: 5px; }
.sub-event .event-cell { display: block; padding: 5px 10px;  }
.factors { display: none; flex: 1 1; }
.f.factor-cell { border-top-right-radius: 5px; }
.l.factor-cell { border-bottom-right-radius: 5px; }
</style>



// WEBPACK FOOTER //
// src/components/sports/matches/Event.vue